import React from 'react'
import { intl } from 'lang/intl'
import { TtTrayChyronOnCamera, TtIcon, TtButton } from '@23/react'
import { FormattedMessage } from 'react-intl'
import {
  useOverlayState,
  setChyron,
  removeOverlay,
} from '../../../../firebase/hooks/useOverlays'
import { ChyronType } from '../../../../firebase/model/chyron-model'
import {
  setActiveCard,
  useTrayCard,
  useTrayCardState,
} from '../../../../firebase/hooks/useTray'

import './ChyronOnCameraCard.scss'
import { PropsWithTrayItemChildren } from '../TrayItem'

interface OnCameraCardProps {
  id: string
}

const OnCameraCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<OnCameraCardProps>) => {
  const card = useTrayCard(id)
  const cardState = useTrayCardState(id)
  const overlayState = useOverlayState()

  const showChyron = () => {
    setChyron({
      type: ChyronType.J2SIntroduction,
    })
  }

  const onCardClickHandler = () => {
    showChyron()
    setActiveCard(id)
  }

  const isChyronShowing = overlayState?.type === ChyronType.J2SIntroduction

  if (card?.type !== 'chyron-on-camera') return null

  return (
    <TtTrayChyronOnCamera
      tag={intl.formatMessage({ defaultMessage: 'Go on Camera' })}
      selected={cardState === 'active'}
      disabled={cardState === 'done'}
      onTt-click={(event) => {
        if (event.target === event.currentTarget) {
          onCardClickHandler()
        }
      }}
    >
      <TtButton
        slot="toolbar"
        label={
          isChyronShowing
            ? intl.formatMessage({ defaultMessage: 'Show OnCamerTvCard' })
            : intl.formatMessage({
                defaultMessage: 'Remove the OnCamera TvCard',
              })
        }
        color="secondary"
        variant="ghost"
        size="x-small"
        circle
        onClick={isChyronShowing ? removeOverlay : showChyron}
      >
        <TtIcon
          library="one/webinars"
          name={isChyronShowing ? 'visibility-off' : 'visibility-on'}
        />
      </TtButton>
      {children?.()}
      <div className="go-on-camera-info">
        <div className="suggestion-text">
          <FormattedMessage
            defaultMessage="You can now request access to go on camera.{linebreak}Just press the {icon} button on top of the sidebar."
            values={{
              icon: (
                <span className="suggestion-text-info">
                  <TtIcon className="mic-icon" name="record" library="23" />
                  <FormattedMessage defaultMessage="Go OnCamera" />
                </span>
              ),
              linebreak: <br />,
            }}
          />
        </div>
      </div>
    </TtTrayChyronOnCamera>
  )
}

export default OnCameraCard
